import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#26ab4d] text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute top-20 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 left-20 w-40 h-40 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-10 right-10 w-20 h-20 border border-white/20 rounded-full"></div>
      </div>
      
      <div className="container mx-auto px-[1.5rem] relative z-10 py-[0.5rem] sm:py-[0.75rem]">
        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-[0.5rem] sm:pt-[0.75rem] pb-[0.5rem] sm:pb-[0.75rem]">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 sm:space-y-3 md:space-y-0">
            <div className="flex items-center space-x-2 sm:space-x-3">
              <div className="text-white/80 text-xs sm:text-xs lg:text-sm font-bold">
                © <span className="text-white font-semibold">Bargad.ai</span>. All rights reserved.
              </div>
            </div>
            <div className="flex flex-wrap justify-center gap-2 sm:gap-3 lg:gap-4 text-xs sm:text-xs">
              <Link to="/business-continuity-policy" className="text-white/80 hover:text-white transition-colors duration-300 cursor-pointer font-bold">BCP Policy</Link>
              <Link to="/privacy-policy" className="text-white/80 hover:text-white transition-colors duration-300 cursor-pointer font-bold">Privacy Policy</Link>
              <span className="text-white/80 hover:text-white transition-colors duration-300 cursor-pointer font-bold">Media</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;